import { useEffect } from 'react';
import getRootElement from '../utils/get-root-element.js';
import useKeepAlive from './use-keep-alive.js';

const EVENT_TYPES = ['mousemove', 'scroll', 'keydown', 'click', 'touchstart'];

const useKeepAliveOnInteraction = () => {
	const { ping } = useKeepAlive();
	const rootElement = getRootElement();

	useEffect(() => {
		const listener = ping; // save the function ref
		EVENT_TYPES.forEach(type => rootElement.addEventListener(type, listener, { passive: true }));
		return () => EVENT_TYPES.forEach(type => rootElement.removeEventListener(type, listener));
	}, [ping, rootElement]);
};

export default useKeepAliveOnInteraction;
